<script lang="ts" context="module">
    import { getTableColumn } from "../../getTableColumns"
    export const getOperationOutTable1Columns: (_showPrices: boolean) => TableColumn[] = (_showPrices) => [
        ...getTableColumn(_showPrices, "operationOut1"),
    ]
    export const getOperationOutTable2Columns: (_showPrices: boolean) => TableColumn[] = (_showPrices) => [
        ...getTableColumn(_showPrices, "operationOut2"),
    ]
</script>

<script lang="ts">
    import { getQueryParam, requireLogin } from "../../helper"
    import { location, openOverlay, overlayTabs, showPrices, login, newNotification } from "../../store"
    import { _ } from "svelte-i18n"

    import Table from "../widgets/Table.svelte"
    import { getOneOperation, getOperation } from "../../api"
    import OperationsFilter from "./operations/OperationsFilter.svelte"
    import OperationsLegend from "./operations/OperationsLegend.svelte"
    import MiniLoader from "../widgets/MiniLoader.svelte"
    import OperationTabNavi from "./operations/OperationTabNavi.svelte"
    import { getFollowUpButton, getOperationButtons } from "./Operations.svelte"
    import { registerEventCallback } from "../../eventBus"
    import TableTop from "./operations/TableTop.svelte"
    export let lang = "de"
    let gridview = false
    let innerWidth = window.innerWidth
    const gridBreakPoint = 600
    let filteropen = false

    let type: number
    let limit = 20
    let offset = 0
    let filter: any = {}
    let rows: OperationOut[] = []
    let showMoreButton = false
    let loading = false
    let sort = "-insertTime"

    let userFilter: []
    let resetFilter: () => void

    requireLogin()

    let abortController: AbortController
    let doNotClose = false
    function load() {
        if (abortController) {
            abortController.abort() // cancel all running requests
        }
        abortController = new AbortController()
        const { signal } = abortController

        loading = true
        getOperation("operation-out", filter, limit, offset, "list", sort, signal)
            .then((r) => {
                r.data = r.data as OperationOut[]
                rows = [...rows, ...r.data]
                offset += limit
                showMoreButton = limit == r.data.length

                const url = new URL(window.location.href)
                const params = new URLSearchParams(url.search)

                for (let [key, value] of params.entries()) {
                    if (key == "id") {
                        const row = rows.find((row) => row.id == value)

                        if (row) openOverlay(row)
                        else
                            getOneOperation(value, "operation-out").then((r) =>
                                !!r
                                    ? openOverlay(r)
                                    : newNotification({
                                          html: $_("operationsOut.entryNotFound"),
                                          class: "error",
                                      })
                            )

                        params.delete("id")
                        url.search = params.toString()
                        window.history.replaceState({}, "", url.toString())
                        doNotClose = true
                    }
                }
            })
            .catch((e) => {})
            .finally(() => {
                loading = false
            })
    }

    $: if ($location.search || sort || userFilter) {
        type = parseInt(getQueryParam("type"))
        if (!doNotClose) {
            $overlayTabs = null
            doNotClose = false
        }
        filter = {}
        filter.type = type
        if (userFilter) {
            filter["$and"] = userFilter
        }
        offset = 0
        rows = []
        if (type) load()
    }

    function updateOperationEntry(operation: OperationOut) {
        let index = rows.findIndex((row) => row.id == operation.id)
        if (index >= 0) rows[index] = operation
        else console.error("Could not find operation with id", operation.id)
    }
    registerEventCallback("operationUpdated", updateOperationEntry)

    $: columns = type == 1 ? getOperationOutTable1Columns($showPrices) : getOperationOutTable2Columns($showPrices)
</script>

<svelte:window bind:innerWidth />

<section class="section_padding" data-lang="{lang}">
    <div class="container_wide">
        <OperationTabNavi {type} isOut />

        <OperationsFilter bind:active="{filteropen}" bind:processedFilter="{userFilter}" {type} bind:resetFilter />

        <TableTop {userFilter} bind:resetFilter {gridBreakPoint} bind:gridview bind:filteropen />
        <Table
            className="operationtable {type == 2 ? 'table_auftraege' : ''}"
            gridview="{gridview || innerWidth <= gridBreakPoint}"
            bind:sort
            {columns}
            buttonsColumn="{{
                label: $_('general.actions'),
                className: 'rueckfrage mw-120 max-w-150 w-120',
            }}"
            followUpColumn="{{
                label: $_('header.watchlist'),
                className: 'mw-160 max-w-180 w-160',
            }}"
            buttons="{getOperationButtons(type, $showPrices, $login?.account)}"
            followUpButton="{getFollowUpButton(type, $showPrices, $login?.account)}"
            {rows}
            on:click="{(r) => {
                openOverlay(r.detail)
            }}"
        />

        {#if loading}
            <div class="centerbutton">
                <br />
                <br />
                <MiniLoader />
            </div>
        {/if}

        {#if showMoreButton && !loading}
            <!-- Load more -->
            <div class="centerbutton">
                <button class="btn loadmore" on:click="{load}">{$_("general.loadMore")}</button>
            </div>
        {/if}

        <OperationsLegend {type} />
    </div>
</section>
